var map = {
	"./cat-multi.jpg": "768b",
	"./cat-single.jpg": "6928",
	"./img-only.jpg": "a7cc",
	"./imgprd.jpg": "70f8",
	"./prd.jpg": "c47b",
	"./prdimg.jpg": "d40f",
	"./prdx2.jpg": "dff4",
	"./slider.jpg": "8dec",
	"./txt-only.jpg": "3659",
	"./txt-title.jpg": "48e8",
	"./video.jpg": "5d79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a720";